import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';

export default function EmptyState({ isAdminView }: { isAdminView: boolean }) {
  return (
    <div className="videos-mobile-empty">
      <span className="videos-mobile-empty-icon">
        <Icon iconType="play" color={cssVar('text-accent')} size="large" />
      </span>
      <p className="videos-mobile-empty-title">Nenhum vídeo nesta categoria</p>
      {isAdminView && (
        <p className="videos-mobile-empty-hint">
          Use
          {' '}
          <strong>Adicionar vídeo</strong>
          {' '}
          para publicar o primeiro boletim.
        </p>
      )}
    </div>
  );
}
